module.exports = __webpack_public_path__ + "static/img/vision.9231cc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/vision.png
// module id = JjxD
// module chunks = 0